import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Image from '../../components/AppImage';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import { MdMenu } from "react-icons/md"; // <-- Import the menu icon


const heroImages = [
  "/assets/images/student-class video.mp4", // <-- Video file as first item
  "/assets/images/student-class.jpeg",
  "/assets/images/hero-section-students.png",
  "/assets/images/hero-section-students 1.png",
  "/assets/images/hero-section 3.jpeg",
];

// Add page-specific CSS in a <style> tag scoped to .landing-page
const landingPageBgStyle = `
.landing-page {
  background: linear-gradient(135deg, #233c2e 0%, #2e2540 100%);
  background-blend-mode: lighten;
  min-height: 100vh;
}
`;

const LandingPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [heroIndex, setHeroIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const videoRef = React.useRef(null);

  React.useEffect(() => {
    setFade(false);
    const timeout = setTimeout(() => setFade(true), 50); // trigger fade-in

    let slideTimeout;
    if (heroImages[heroIndex].endsWith('.mp4')) {
      // Video: wait for 15s or video end (whichever comes first)
      slideTimeout = setTimeout(() => {
        setFade(false);
        setTimeout(() => setHeroIndex((prev) => (prev + 1) % heroImages.length), 400);
      }, 15000);
    } else {
      // Image: 5s
      slideTimeout = setTimeout(() => {
        setFade(false);
        setTimeout(() => setHeroIndex((prev) => (prev + 1) % heroImages.length), 400);
      }, 5000);
    }

    return () => {
      clearTimeout(slideTimeout);
      clearTimeout(timeout);
    };
  }, [heroIndex]);

  const achievements = [
    {
      icon: 'Award',
      title: 'Academic Excellence',
      description: 'Consistently ranked among top educational institutions in the region with outstanding academic performance.',
      stats: '95% Pass Rate'
    },
    {
      icon: 'Building',
      title: 'Modern Facilities',
      description: 'State-of-the-art classrooms, laboratories, library, and sports facilities to enhance learning experience.',
      stats: '20+ Facilities'
    },
    {
      icon: 'Users',
      title: 'Student Success',
      description: 'Dedicated to nurturing life-long learners with personalized attention and comprehensive development.',
      stats: '1000+ Alumni'
    }
  ];

  const testimonials = [
    {
      name: 'Cynthia Amaka',
      role: 'Parent',
      content: 'Anglican College Owerrinta has truly transformed my child\'s learning journey. The dedicated teachers and excellent facilities make it outstanding.',
      rating: 5
    },
    {
      name: 'Michael Chibueze',
      role: 'Alumni',
      content: 'The foundation I received here prepared me for university and beyond. The emphasis on life-long learning is remarkable.',
      rating: 5
    },
    {
      name: 'Ebuka David',
      role: 'Parent',
      content: 'I love the interactive learning environment and the support from teachers. This school truly cares about each student.',
      rating: 5
    }
  ];

  // Team of Formators data
  const formators = [
    {
      name: "Rev. Canon John Doe",
      title: "Principal",
      image: "/assets/images/principal.jpg",
      bio: "Rev. Canon John Doe is the dedicated Principal of Anglican College Owerrinta. His leadership, vision, and commitment to holistic education inspire both staff and students to pursue excellence in academics, faith, and character.",
      quote: "Excellence through diligence is our guiding principle."
    },
    {
      name: "Mrs. Jane Smith",
      title: "Vice Principal",
      image: "/assets/images/vice-principal.jpg",
      bio: "Mrs. Jane Smith assists in the holistic development of students, focusing on their academic and moral growth.",
      quote: "Every student is a seed of hope for the future."
    },
    {
      name: "Mr. Peter Okafor",
      title: "Dean of Studies",
      image: "/assets/images/dean.jpg",
      bio: "Mr. Peter Okafor coordinates academic programs, ensuring high standards and fostering a culture of learning.",
      quote: "Academic excellence is the foundation for future leaders."
    },
    {
      name: "Mrs. Grace Nwosu",
      title: "Guidance Counselor",
      image: "/assets/images/counselor.jpg",
      bio: "Mrs. Grace Nwosu provides guidance and support to all students, nurturing their growth and aspirations.",
      quote: "Guidance is a journey of growth and achievement."
    }
  ];

  const handleNavigation = (path) => {
    window.location.href = path;
  };

  return (
    <>
      <style>{landingPageBgStyle}</style>
      <div className="landing-page min-h-screen bg-background">
        {/* Navigation Header */}
        <header className="fixed top-0 left-0 right-0 bg-card/95 backdrop-blur-md border-b border-border z-50">
          <div className="container mx-auto px-4 lg:px-6">
            <div className="flex items-center justify-between h-16">
              {/* Logo */}
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 rounded-full overflow-hidden">
                  <Image 
                    src="/assets/images/school_logo-1754996036714.jpg"
                    alt="Anglican College Owerrinta Logo"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h1 className="font-heading font-bold text-lg text-foreground">ANGLICAN COLLEGE OWERRINTA</h1>
                  <p className="font-caption text-xs text-muted-foreground">Excellence Through Diligence</p>
                </div>
              </div>

              {/* Desktop Navigation */}
              <nav className="hidden md:flex items-center space-x-6">
                <button 
                  onClick={() => handleNavigation('/about-page')}
                  className="font-body text-sm text-foreground hover:text-primary transition-colors"
                >
                  About
                </button>
             <button 
  onClick={() => handleNavigation('/admissions&programs')}
  className="font-body text-sm text-foreground hover:text-primary transition-colors"
>
  Admissions & Updates
</button>
                <button 
                  onClick={() => handleNavigation('/contact')}
                  className="font-body text-sm text-foreground hover:text-primary transition-colors"
                >
                  Contact
                </button>
              </nav>

              {/* CTA Buttons */}
              <div className="hidden md:flex items-center space-x-3">
                <Button 
                  variant="outline" 
                  onClick={() => handleNavigation('/login-authentication')}
                  className="font-body text-sm"
                >
                    Login
                </Button>
              </div>

              {/* Mobile Menu Toggle - use MdMenu for mobile */}
              <button
                className="md:hidden p-2 rounded-lg focus:outline-none"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Open menu"
              >
                <MdMenu size={28} className="menu-icon" />
              </button>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
              <motion.div 
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                className="md:hidden border-t border-border bg-card py-4"
              >
                <nav className="flex flex-col space-y-3">
                  <button 
                    onClick={() => handleNavigation('/about-page')}
                    className="text-left font-body text-sm text-foreground hover:text-primary"
                  >
                    About
                  </button>
                  <button 
  onClick={() => handleNavigation('/admissions&programs')}
  className="text-left font-body text-sm text-foreground hover:text-primary"
>
  Admissions & Updates
</button>
                  <button 
                    onClick={() => handleNavigation('/contact')}
                    className="text-left font-body text-sm text-foreground hover:text-primary"
                  >
                    Contact
                  </button>
                  <div className="flex flex-col space-y-2 pt-2 border-t border-border">
                    <Button 
                      variant="outline" 
                      onClick={() => handleNavigation('/login-authentication')}
                      className="font-body text-sm justify-start"
                    >
                      Login
                    </Button>
                  </div>
                </nav>
              </motion.div>
            )}
          </div>
        </header>
        {/* Hero Section */}
        <section className="relative pt-24 min-h-[90vh] flex items-center justify-center overflow-hidden">
          {/* Background Image/Video Slideshow */}
          <div className="absolute inset-0 transition-all duration-700" aria-hidden="true">
            {heroImages[heroIndex].endsWith('.mp4') ? (
              <video
                key={heroImages[heroIndex]} // force reload on src change
                ref={videoRef}
                src={heroImages[heroIndex]}
                autoPlay
                muted
                loop={false}
                playsInline
                preload="auto"
                poster="/assets/images/student-class.jpeg" // fallback poster
                className={`w-full h-full object-cover absolute inset-0 transition-opacity duration-500 ${fade ? 'opacity-100' : 'opacity-0'}`}
                onEnded={() => {
                  setFade(false);
                  setTimeout(() => setHeroIndex((prev) => (prev + 1) % heroImages.length), 400);
                }}
              />
            ) : (
              <div
                key={heroImages[heroIndex]}
                className={`w-full h-full bg-cover bg-center absolute inset-0 transition-opacity duration-500 ${fade ? 'opacity-100' : 'opacity-0'}`}
                style={{ backgroundImage: `url('${heroImages[heroIndex]}')` }}
              />
            )}
            <div className="absolute inset-0 bg-black/30"></div>
            <div className="absolute inset-0 bg-gradient-to-b from-[#233c2e]/80 via-[#2e2540]/70 to-black/60 pointer-events-none" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/10 pointer-events-none" />
          </div>

          {/* Centered Content */}
          <div className="container mx-auto px-2 sm:px-4 relative z-10 flex flex-col items-center justify-center min-h-[90vh]">
            <div className="flex flex-col items-center w-full max-w-3xl mx-auto mt-8 sm:mt-16 lg:mt-24">
              <div className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6 sm:mb-8 rounded-full overflow-hidden shadow-2xl bg-white flex items-center justify-center border-4 border-primary/30">
                <Image
                  src="/assets/images/school_logo-1754996036714.jpg"
                  alt="Anglican College Owerrinta Logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <h1
                className="text-2xl xs:text-3xl sm:text-4xl lg:text-7xl font-heading font-extrabold text-white mb-3 sm:mb-4 text-center leading-tight drop-shadow-xl tracking-wide"
                style={{
                  textShadow: '0 4px 24px rgba(34,60,46,0.7), 0 1px 0 #000',
                  letterSpacing: '0.04em'
                }}
              >
                ANGLICAN COLLEGE OWERRINTA
              </h1>
              <p
                className="text-lg xs:text-xl sm:text-2xl lg:text-4xl font-body font-semibold mb-4 sm:mb-6 text-center tracking-wide"
                style={{
                  color: '#e0e7ef',
                  textShadow: '0 2px 12px #2e2540cc, 0 1px 0 #000'
                }}
              >
                Excellence Through Diligence
              </p>
              <p
                className="text-base xs:text-lg sm:text-xl max-w-2xl mx-auto mb-6 sm:mb-8 text-center font-body font-medium"
                style={{
                  background: 'rgba(34,60,46,0.92)',
                  borderRadius: '1rem',
                  padding: '1rem 1.5rem',
                  boxShadow: '0 2px 24px #2e254033',
                  color: '#fff',
                  fontWeight: 500,
                }}
              >
                Where tradition meets innovation. We empower students with world-class education, foster critical thinking, and build character for a successful future in an ever-evolving world.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center w-full">
                <Button
                  variant="outline"
                  size="lg"
                  onClick={() => handleNavigation('/login-authentication')}
                  className="font-body text-white border-white hover:bg-white hover:text-primary w-full sm:w-auto shadow-lg"
                  style={{
                    background: 'rgba(46,37,64,0.7)',
                    borderWidth: 2,
                  }}
                >
                  <Icon name="LogIn" size={20} className="mr-2" />
                  Login
                </Button>
              </div>
              {/* Quick Stats */}
              <div className="flex flex-wrap gap-6 sm:gap-8 justify-center mt-8 sm:mt-12 w-full">
                <div className="text-center flex-1 min-w-[90px]">
                  <p className="text-2xl sm:text-3xl lg:text-4xl font-heading font-bold text-primary drop-shadow">500+</p>
                  <p className="text-sm sm:text-base font-body text-white/90">Students</p>
                </div>
                <div className="text-center flex-1 min-w-[90px]">
                  <p className="text-2xl sm:text-3xl lg:text-4xl font-heading font-bold text-primary drop-shadow">50+</p>
                  <p className="text-sm sm:text-base font-body text-white/90">Teachers</p>
                </div>
                <div className="text-center flex-1 min-w-[90px]">
                  <p className="text-2xl sm:text-3xl lg:text-4xl font-heading font-bold text-primary drop-shadow">95%</p>
                  <p className="text-sm sm:text-base font-body text-white/90">Success Rate</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Rector's Welcome Address Section */}
        <section className="py-16 bg-card/80 border-y border-border">
          <div className="container mx-auto px-4 lg:px-6 flex flex-col md:flex-row items-center gap-10">
            {/* Rector's Image */}
            <div className="flex-shrink-0 w-full md:w-64 flex justify-center mb-8 md:mb-0">
              <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-primary/30 shadow-lg bg-white flex items-center justify-center">
                <Image
                  src="/assets/images/director-pic.jpeg"
                  alt="Principal Anglican College Owerrinta"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            {/* Welcome Address Content */}
            <div className="flex-1">
              <h2 className="text-2xl lg:text-3xl font-heading font-bold text-primary mb-4">
                Welcome Address from the Principal
              </h2>
              <p className="text-lg text-muted-foreground mb-4 font-body">
                Dear Parents, Guardians, and Friends,<br />
                On behalf of the entire Anglican College Owerrinta community, I warmly welcome you to our esteemed institution—a place where academic excellence, character, and leadership are nurtured in every student entrusted to our care.
              </p>
              <p className="text-base text-foreground mb-4 font-body">
                At Anglican College Owerrinta, we believe that true education is a partnership between the school, families, and the wider community. Your support, encouragement, and involvement are invaluable as we guide our students on their journey of academic, moral, and personal growth.
              </p>
              {/* Collapsible full address */}
              <WelcomeAddressFull />
            </div>
          </div>
        </section>
        
        {/* Founder & Director Section */}
        <section className="py-16 bg-muted/10">
          <div className="container mx-auto px-0 lg:px-0">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="flex flex-col items-center justify-center w-full"
            >
              <div className="w-full flex justify-center items-center mb-6">
                <div className="flex flex-col items-center w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl 2xl:max-w-2xl">
                  <div className="relative w-full aspect-[4/5]">
                    {/* Frame */}
                    <div className="absolute inset-0 rounded-2xl border-4 border-primary/40 shadow-xl pointer-events-none z-10"></div>
                    {/* Image fills the card */}
                    <Image
                      src="/assets/images/Proprietor-pic.png"
                      alt="Archbishop Isaac Chijioke Nwaobia, PhD, MSW, B.A., PGD (Journalism)"
                      className="w-full h-full object-cover rounded-2xl"
                      style={{ position: 'absolute', inset: 0 }}
                    />
                  </div>
                </div>
              </div>
              <h2 className="text-2xl sm:text-3xl font-heading font-bold text-primary text-center mb-2">
               The Proprietor
              </h2>
              <p className="text-center text-lg font-semibold text-foreground mb-1">
                Archbishop Isaac Chijioke Nwaobia, PhD, MSW, B.A., PGD (Journalism), Dip.Th, JP
              </p>
              <div className="max-w-2xl mx-auto mt-3">
                <p className="text-base sm:text-lg text-muted-foreground text-center font-body leading-relaxed">
                  Archbishop Isaac Chijioke Nwaobia, PhD, MSW, B.A., PGD (Journalism), Dip.Th, JP, is a visionary leader and the driving force behind Anglican College Owerrinta. As the Director, he is dedicated to fostering an environment where academic excellence, moral integrity, and holistic development are at the forefront. His unwavering commitment to quality education and community service continues to inspire both staff and students to reach their highest potential.
                </p>
              </div>
            </motion.div>
          </div>
        </section>
        
        {/* Proprietress Section (insert after Proprietor section, before Students Group Photo) */}
<section className="py-16 bg-muted/10">
  <div className="container mx-auto px-0 lg:px-0">
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.1 }}
      className="flex flex-col items-center justify-center w-full"
    >
      <div className="w-full flex justify-center items-center mb-6">
        <div className="flex flex-col items-center w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl 2xl:max-w-2xl">
          <div className="relative w-full aspect-[4/5]">
            {/* Frame */}
            <div className="absolute inset-0 rounded-2xl border-4 border-primary/40 shadow-xl pointer-events-none z-10"></div>
            {/* Image fills the card */}
            <Image
              src="/assets/images/Proprietress-pic.png"
              alt="Proprietress Anglican College Owerrinta"
              className="w-full h-full object-cover rounded-2xl"
              style={{ position: 'absolute', inset: 0 }}
            />
          </div>
        </div>
      </div>
      <h2 className="text-2xl sm:text-3xl font-heading font-bold text-primary text-center mb-2">
        The Proprietress
      </h2>
      <p className="text-center text-lg font-semibold text-foreground mb-1">
        Mrs. Hope Njideka Nwaobia
      </p>
      <div className="max-w-2xl mx-auto mt-3">
        <p className="text-base sm:text-lg text-muted-foreground text-center font-body leading-relaxed">
          As Proprietress of Anglican College Owerrinta, Mrs. Hope Njideka Nwaobia exemplifies dedication, compassion, and a steadfast commitment to the holistic development of every student. Her nurturing leadership and unwavering support inspire both staff and students to pursue excellence, integrity, and service to the community.
        </p>
      </div>
    </motion.div>
  </div>
</section>
        {/* Students Group Photo Section */}
        <section className="py-12 bg-muted/10">
          <div className="container mx-auto px-0 lg:px-0 flex flex-col items-center">
            <div className="w-full max-w-4xl rounded-2xl overflow-hidden shadow-2xl border-4 border-primary/30 bg-white">
              <Image
                src="/assets/images/students-pic.jpeg"
                alt="Anglican College Owerrinta Students Group"
                className="w-full h-[340px] object-cover object-center"
              />
            </div>
            <p className="mt-6 text-center text-lg sm:text-xl font-semibold text-primary max-w-2xl mx-auto px-2">
              <span className="block">
                United in Excellence, Character, and Purpose — The vibrant students of Anglican College Owerrinta, where every child is inspired to lead, achieve, and shine.
              </span>
            </p>
          </div>
        </section>

        {/* School Promo Image & Anthem Section */}
        <section className="py-12 bg-muted/10">
          <div className="container mx-auto px-0 lg:px-0">
            <div className="flex flex-col lg:flex-row items-center justify-center gap-10">
              {/* Seminarians Image */}
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1 }}
                className="flex-1 w-full max-w-3xl"
                style={{ minWidth: 0 }}
              >
                <div className="aspect-[16/9] rounded-3xl border-4 border-primary/40 bg-white shadow-2xl flex items-center justify-center overflow-hidden">
                  <Image
                    src="/assets/images/hero-section-students 1.png"
                    alt="Seminarians Group"
                    className="w-full h-full object-cover"
                    style={{ width: '100%', height: '100%' }}
                  />
                </div>
              </motion.div>
              {/* School Anthem */}
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.1 }}
                className="flex-1 w-full max-w-xl"
                style={{ minWidth: 0 }}
              >
                <div className="bg-card border border-primary/30 rounded-2xl shadow-xl p-6 flex flex-col h-full justify-center">
                  <h3 className="text-2xl font-heading font-bold text-primary mb-4 text-center lg:text-left">
                    School Anthem
                  </h3>
                   <div className="whitespace-pre-line text-base sm:text-lg font-body text-muted-foreground text-center lg:text-left leading-relaxed">
                    Great Anglican College<br />
                    Arise and shine, DC<br />
                    Builders of future leaders<br />
                    A paragon vision<br />
                    A citadel of academic Excellence<br />
                    We set the pace & others follow<br />
                    Great Anglican College<br />
                    Arise and shine DC.<br /><br />
                    Achievers of excellence<br />
                    Through diligence<br />
                    God on our side, we shall get to any height<br />
                    We show the lead and others follow.<br />
                    Part-finders - Arise & Shine<br />
                    Pace-setters - Arise & Shine<br />
                    World changers - Arise & Shine
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Musical Students Section (replaces Jesus Image Section) */}
        <section className="py-12 bg-muted/10">
          <div className="container mx-auto px-0 lg:px-0">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="flex flex-col items-center justify-center w-full"
            >
              <div className="w-full max-w-3xl mx-auto aspect-[16/9] rounded-3xl border-4 border-accent/40 bg-white shadow-2xl flex items-center justify-center overflow-hidden">
                <Image
                  src="/assets/images/musical-stundets.jpg"
                  alt="Anglican College Owerrinta Music Students"
                  className="w-full h-full object-cover"
                  style={{ width: '100%', height: '100%' }}
                />
              </div>
              <p className="mt-6 text-center text-lg sm:text-xl font-semibold text-primary max-w-2xl mx-auto px-2">
                <span className="block">
                  Excellence in Harmony — Anglican College Owerrinta’s talented music students mastering instruments and vocals in a world-class environment, where creativity and discipline unite for outstanding performance.
                </span>
              </p>
            </motion.div>
          </div>
        </section>

        {/* Tailoring Students Section */}
        <section className="py-12 bg-muted/10">
          <div className="container mx-auto px-0 lg:px-0">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="flex flex-col items-center justify-center w-full"
            >
              <div className="w-full max-w-3xl mx-auto aspect-[16/9] rounded-3xl border-4 border-primary/40 bg-white shadow-2xl flex items-center justify-center overflow-hidden">
                <Image
                  src="/assets/images/tailoring-students.jpeg"
                  alt="Anglican College Owerrinta Tailoring Students"
                  className="w-full h-full object-cover"
                  style={{ width: '100%', height: '100%' }}
                />
              </div>
              <p className="mt-6 text-center text-lg sm:text-xl font-semibold text-primary max-w-2xl mx-auto px-2">
                <span className="block">
                  Crafting Skills for the Future — Anglican College Owerrinta’s tailoring students excel in practical fashion and design, blending creativity with technical expertise for real-world success.
                </span>
              </p>
            </motion.div>
          </div>
        </section>

        {/* Student Classroom Section (NEW, after tailoring students, before founder) */}
        <section className="py-12 bg-muted/10">
          <div className="container mx-auto px-0 lg:px-0">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="flex flex-col items-center justify-center w-full"
            >
              <div className="w-full max-w-3xl mx-auto aspect-[16/9] rounded-3xl border-4 border-accent/40 bg-white shadow-2xl flex items-center justify-center overflow-hidden">
                <Image
                  src="/assets/images/student-class.jpeg"
                  alt="Anglican College Owerrinta Classroom"
                  className="w-full h-full object-cover"
                  style={{ width: '100%', height: '100%' }}
                />
              </div>
              <p className="mt-6 text-center text-lg sm:text-xl font-semibold text-accent max-w-2xl mx-auto px-2">
                <span className="block">
                  Focused Learning in Action — Anglican College Owerrinta’s vibrant classroom environment fosters engagement, discipline, and academic excellence, preparing students for a lifetime of achievement.
                </span>
              </p>
            </motion.div>
          </div>
        </section>

        {/* Principal Section */}
        <section className="py-20 bg-gradient-to-br from-primary/10 via-background to-accent/10">
          <div className="container mx-auto px-4 lg:px-6">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="max-w-2xl mx-auto mb-16 text-center"
            >
              <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
                Meet Our Principal
              </h2>
              <p className="text-lg text-muted-foreground">
                Leadership, vision, and dedication to excellence—meet the head of Anglican College Owerrinta.
              </p>
            </motion.div>
            <div className="flex flex-col items-center justify-center">
              <div className="w-40 h-40 sm:w-56 sm:h-56 rounded-full overflow-hidden mb-6 border-4 border-primary/30 shadow-xl flex items-center justify-center bg-white">
                <Image
                  src="/assets/images/director-pic.jpeg"
                  alt="Principal Anglican College Owerrinta"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-2xl font-heading font-bold text-primary mb-2">Mrs Chinenye Confidence Imuo</h3>
              <p className="text-base sm:text-lg text-muted-foreground max-w-2xl text-center mb-4">
                As Principal of Anglican College Owerrinta, 'Mrs. Chinenye Confidence Imuo' leads with passion, integrity, and a commitment to nurturing every student’s academic and personal growth. Her vision for the college is rooted in excellence, discipline, and holistic development, ensuring that every child is empowered to reach their full potential in a supportive and inspiring environment.
              </p>
              <blockquote className="italic text-primary border-l-4 border-primary pl-3 mb-0 text-sm sm:text-base max-w-xl text-center">
                "At Anglican College Owerrinta, we believe in raising leaders of tomorrow through diligence, character, and a love for learning."
              </blockquote>
            </div>
          </div>
        </section>

        {/* Achievements Section */}
        <section className="py-20 bg-muted/30">
          <div className="container mx-auto px-4 lg:px-6">
            <motion.div 
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="text-center mb-16"
            >
              <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
                Why Choose ANGLICAN COLLEGE OWERRINTA?
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Anglican College Owerrinta stands out for its commitment to academic excellence, moral upbringing, and holistic development. We nurture future leaders with strong values, innovative learning, and a supportive environment.
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <motion.div
                key="Academic Excellence"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.1 }}
                className="bg-card border border-border rounded-xl p-6 text-center hover:shadow-lg transition-shadow"
              >
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name="Award" size={28} className="text-primary" />
                </div>
                <h3 className="text-xl font-heading font-semibold text-foreground mb-3">
                  Academic Excellence
                </h3>
                <p className="text-muted-foreground mb-4 font-body">
                  Renowned for outstanding academic performance and a culture of diligence, preparing students for higher education and life.
                </p>
                <div className="text-2xl font-heading font-bold text-primary">
                  95% Pass Rate
                </div>
              </motion.div>
              <motion.div
                key="Modern Facilities"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.2 }}
                className="bg-card border border-border rounded-xl p-6 text-center hover:shadow-lg transition-shadow"
              >
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name="Building" size={28} className="text-primary" />
                </div>
                <h3 className="text-xl font-heading font-semibold text-foreground mb-3">
                  Modern Facilities
                </h3>
                <p className="text-muted-foreground mb-4 font-body">
                  Well-equipped classrooms, laboratories, library, and sports facilities to support a vibrant learning experience.
                </p>
                <div className="text-2xl font-heading font-bold text-primary">
                  20+ Facilities
                </div>
              </motion.div>
              <motion.div
                key="Student Success"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.3 }}
                className="bg-card border border-border rounded-xl p-6 text-center hover:shadow-lg transition-shadow"
              >
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name="Users" size={28} className="text-primary" />
                </div>
                <h3 className="text-xl font-heading font-semibold text-foreground mb-3">
                  Student Success
                </h3>
                <p className="text-muted-foreground mb-4 font-body">
                  We nurture well-rounded individuals with strong character, leadership skills, and a passion for lifelong learning.
                </p>
                <div className="text-2xl font-heading font-bold text-primary">
                  1000+ Alumni
                </div>
              </motion.div>
            </div>
          </div>
        </section>
       
        {/* Value Proposition Section */}
        <section className="py-20 bg-gradient-to-br from-accent/10 via-background to-primary/10">
          <div className="container mx-auto px-4 lg:px-6">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="max-w-2xl mx-auto mb-16 text-center"
            >
              <h2 className="text-3xl lg:text-4xl font-heading font-bold text-primary mb-4">
                Our Promise to Every Student
              </h2>
              <p className="text-lg text-muted-foreground">
                At Anglican College Owerrinta, we are dedicated to providing a nurturing environment, quality education, and opportunities for every student to excel academically, morally, and socially.
              </p>
            </motion.div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.1 }}
                className="bg-card border border-primary/20 rounded-xl p-6 text-center shadow hover:shadow-lg transition-shadow"
              >
                <Icon name="Heart" size={32} className="text-primary mx-auto mb-4" />
                <h3 className="text-xl font-heading font-semibold text-primary mb-2">Caring Community</h3>
                <p className="text-muted-foreground font-body">
                  Supportive teachers and staff who care about every student’s growth, well-being, and success.
                </p>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.2 }}
                className="bg-card border border-primary/20 rounded-xl p-6 text-center shadow hover:shadow-lg transition-shadow"
              >
                <Icon name="Lightbulb" size={32} className="text-primary mx-auto mb-4" />
                <h3 className="text-xl font-heading font-semibold text-primary mb-2">Holistic Development</h3>
                <p className="text-muted-foreground font-body">
                  Academic, moral, and personal growth that prepares students for higher education and responsible citizenship.
                </p>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.3 }}
                className="bg-card border border-primary/20 rounded-xl p-6 text-center shadow hover:shadow-lg transition-shadow"
              >
                <Icon name="Trophy" size={32} className="text-primary mx-auto mb-4" />
                <h3 className="text-xl font-heading font-semibold text-primary mb-2">Opportunities to Excel</h3>
                <p className="text-muted-foreground font-body">
                  A wide range of academic, leadership, and extracurricular programs to help students discover and develop their talents.
                </p>
              </motion.div>
            </div>
          </div>
        </section>
        {/* Activities & Clubs Section */}
        <section className="py-20 bg-gradient-to-br from-primary/10 via-background to-accent/10">
          <div className="container mx-auto px-4 lg:px-6">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="max-w-2xl mx-auto mb-16 text-center"
            >
              <h2 className="text-3xl lg:text-4xl font-heading font-bold text-primary mb-4">
                Life Beyond the Classroom
              </h2>
              <p className="text-lg text-muted-foreground">
                At Anglican College Owerrinta, our students enjoy a vibrant array of clubs, sports, and creative activities that build confidence, teamwork, and leadership for life.
              </p>
            </motion.div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1 }}
                className="bg-card rounded-xl shadow-lg p-6 flex flex-col items-center text-center"
              >
                <Icon name="Football" size={36} className="text-accent mb-4" />
                <h3 className="text-xl font-heading font-semibold text-primary mb-2">Sports & Fitness</h3>
                <p className="text-muted-foreground font-body">
                  Football, basketball, athletics and more—our sports programs encourage teamwork, discipline, and healthy living.
                </p>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.1 }}
                className="bg-card rounded-xl shadow-lg p-6 flex flex-col items-center text-center"
              >
                <Icon name="Music" size={36} className="text-accent mb-4" />
                <h3 className="text-xl font-heading font-semibold text-primary mb-2">Music & Arts</h3>
                <p className="text-muted-foreground font-body">
                  Choir, drama, and art clubs help students express themselves and discover new talents.
                </p>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.2 }}
                className="bg-card rounded-xl shadow-lg p-6 flex flex-col items-center text-center"
              >
                <Icon name="Code" size={36} className="text-accent mb-4" />
                <h3 className="text-xl font-heading font-semibold text-primary mb-2">Intellectual & Innovation Clubs</h3>
                <p className="text-muted-foreground font-body">
                  Science, debate, and technology clubs prepare students for the future and foster curiosity.
                </p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Core Values Section */}
        <section className="py-20 bg-gradient-to-br from-primary/10 via-background to-accent/10">
          <div className="container mx-auto px-4 lg:px-6">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="max-w-2xl mx-auto mb-16 text-center"
            >
              <h2 className="text-3xl lg:text-4xl font-heading font-bold text-primary mb-4">
                Our Core Values
              </h2>
              <p className="text-lg text-muted-foreground">
                The foundation of Anglican College Owerrinta is built on values that shape our students for life, leadership, and service to society.
              </p>
            </motion.div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1 }}
                className="bg-card rounded-xl shadow-lg p-6 flex flex-col items-center text-center"
              >
                <Icon name="ShieldCheck" size={36} className="text-primary mb-4" />
                <h3 className="text-xl font-heading font-semibold text-primary mb-2">Integrity</h3>
                <p className="text-muted-foreground font-body">
                  We instill honesty, responsibility, and strong moral principles in every student.
                </p>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.1 }}
                className="bg-card rounded-xl shadow-lg p-6 flex flex-col items-center text-center"
              >
                <Icon name="Users" size={36} className="text-primary mb-4" />
                <h3 className="text-xl font-heading font-semibold text-primary mb-2">Respect</h3>
                <p className="text-muted-foreground font-body">
                  We celebrate diversity and foster a culture of respect for self, others, and our community.
                </p>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.2 }}
                className="bg-card rounded-xl shadow-lg p-6 flex flex-col items-center text-center"
              >
                <Icon name="TrendingUp" size={36} className="text-primary mb-4" />
                <h3 className="text-xl font-heading font-semibold text-primary mb-2">Excellence</h3>
                <p className="text-muted-foreground font-body">
                  We encourage our students to strive for their best in academics, character, and leadership.
                </p>
              </motion.div>
            </div>
          </div>
        </section>
        {/* Testimonials Section */}
        <section className="py-20">
          <div className="container mx-auto px-4 lg:px-6">
            <motion.div 
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="text-center mb-16"
            >
              <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
                What Our Community Says
              </h2>
              <p className="text-lg text-muted-foreground">
                Hear from parents, students, and alumni about their Anglican College Owerrinta experience.
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <motion.div
                key="cynthia amaka"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.1 }}
                className="bg-card border border-border rounded-xl p-6"
              >
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Icon key={i} name="Star" size={16} className="text-secondary fill-current" />
                  ))}
                </div>
                <p className="text-muted-foreground mb-4 font-body italic">
                  "Anglican College Owerrinta has truly transformed my child's learning journey. The dedicated teachers and excellent facilities make it outstanding."
                </p>
                <div>
                  <p className="font-heading font-semibold text-foreground">Cynthia Amaka</p>
                  <p className="text-sm text-muted-foreground">Parent</p>
                </div>
              </motion.div>
              <motion.div
                key="Michael chibueze"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.2 }}
                className="bg-card border border-border rounded-xl p-6"
              >
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Icon key={i} name="Star" size={16} className="text-secondary fill-current" />
                  ))}
                </div>
                <p className="text-muted-foreground mb-4 font-body italic">
                  "The foundation I received here prepared me for university and beyond. The emphasis on life-long learning is remarkable."
                </p>
                <div>
                  <p className="font-heading font-semibold text-foreground">Michael Chibueze</p>
                  <p className="text-sm text-muted-foreground">Alumni</p>
                </div>
              </motion.div>
              <motion.div
                key="Ebuka David"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.3 }}
                className="bg-card border border-border rounded-xl p-6"
              >
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Icon key={i} name="Star" size={16} className="text-secondary fill-current" />
                  ))}
                </div>
                <p className="text-muted-foreground mb-4 font-body italic">
                  "I love the interactive learning environment and the support from teachers. This school truly cares about each student."
                </p>
                <div>
                  <p className="font-heading font-semibold text-foreground">Ebuka David</p>
                  <p className="text-sm text-muted-foreground">Parent</p>
                </div>
              </motion.div>
            </div>
          </div>
        </section>


        {/* Footer */}
        <footer className="bg-blue-100 border-t border-border py-12">
          <div className="container mx-auto px-4 lg:px-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              {/* School Info */}
              <div className="col-span-1 md:col-span-2">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <Image 
                      src="/assets/images/school_logo-1754996036714.jpg"
                      alt="Anglican College Owerrinta Logo"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-foreground">ANGLICAN COLLEGE OWERRINTA</h3>
                    <p className="font-caption text-sm text-muted-foreground">Excellence Through Diligence</p>
                  </div>
                </div>
                <p className="text-muted-foreground font-body mb-4">
                  Committed to providing exceptional education and fostering the growth of future leaders through innovative teaching methods and character development.
                </p>
                <div className="flex space-x-4">
                  <Button variant="ghost" size="icon">
                    <Icon name="Facebook" size={20} />
                  </Button>
                  <Button variant="ghost" size="icon">
                    <Icon name="Twitter" size={20} />
                  </Button>
                  <Button variant="ghost" size="icon">
                    <Icon name="Instagram" size={20} />
                  </Button>
                </div>
              </div>

              {/* Quick Links */}
              <div>
                <h4 className="font-heading font-semibold text-foreground mb-4">Quick Links</h4>
                <ul className="space-y-2 font-body text-sm">
                  <li><button onClick={() => handleNavigation('/about-page')} className="text-muted-foreground hover:text-primary">About Us</button></li>
                  <li><button onClick={() => handleNavigation('/admissions&programs')} className="text-muted-foreground hover:text-primary">Admissions & Updates</button></li>
                  <li><button className="text-muted-foreground hover:text-primary">Faculty</button></li>
                  <li><button onClick={() => handleNavigation('/contact')} className="text-muted-foreground hover:text-primary">Contact</button></li>
                </ul>
              </div>

              {/* Contact */}
              <div>
                <h4 className="font-heading font-semibold text-foreground mb-4">Contact Info</h4>
                <ul className="space-y-2 font-body text-sm text-muted-foreground">
                  <li className="flex items-center space-x-2">
                    <Icon name="MapPin" size={16} />
                    <span>Isiala Ngwa South, Abia State</span>
                  </li>
                    <li>
                    <h4 className="font-heading font-semibold text-primary mt-4 mb-2">School Support</h4>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="Phone" size={16} />
                    <span>
                      <a href="/call?number=+2348166993771" className="underline text-primary hover:text-primary/80 transition">+2348166993771</a>
                    </span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="Phone" size={16} />
                    <span>
                      <a href="/call?number=+2349077364848" className="underline text-primary hover:text-primary/80 transition">+2349077364848</a>
                    </span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="Phone" size={16} />
                    <span>
                      <a href="/call?number=+2348063425289" className="underline text-primary hover:text-primary/80 transition">+2348063425289</a>
                    </span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="Mail" size={16} />
                    <span>
                      <a href="mailto:anglicancollegesnrsch@gmail.com" className="underline text-primary hover:text-primary/80 transition">anglicancollegesnrsch@gmail.com</a>
                    </span>
                  </li>
                  {/* Technical Support Header and Numbers */}
                  <li>
                    <h4 className="font-heading font-semibold text-primary mt-4 mb-2">Technical Support</h4>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="Smartphone" size={16} />
                    <span>
                      WhatsApp: <a href="https://wa.me/2348143316441" className="underline text-primary">+2348143316441</a>
                    </span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="Phone" size={16} />
                    <span>
                      Call: <a href="/call?number=+2349040744911" className="underline text-primary hover:text-primary/80 transition">+2349040744911</a>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default LandingPage;

function WelcomeAddressFull() {
  const [showFull, setShowFull] = useState(false);
  return (
    <div>
      {!showFull ? (
        <>
          <p className="text-base text-muted-foreground mb-4 font-body">
            We invite you to be active partners in this mission, sharing in our vision to form future leaders for society. Together, let us create an environment where every student can thrive, discover their potential, and become a beacon of excellence and service.
          </p>
          <Button
            variant="outline"
            size="sm"
            className="text-primary border-primary"
            onClick={() => setShowFull(true)}
          >
            Read More
          </Button>
        </>
      ) : (
        <div className="mt-4">
          <p className="text-base text-muted-foreground mb-4 font-body">
            We invite you to be active partners in this mission, sharing in our vision to form future leaders for society. Together, let us create an environment where every student can thrive, discover their potential, and become a beacon of excellence and service.<br /><br />
            Our doors are always open to you. We encourage you to visit, participate in our events, and engage with our teachers and staff. Your presence and involvement enrich our school life and inspire our students to reach greater heights.<br /><br />
            May God bless you abundantly for your trust and commitment. We look forward to a fruitful partnership and a rewarding experience for your children and all members of our school family.<br /><br />
            With gratitude and best wishes,<br />
            <span className="font-heading font-bold text-primary">Principal, Anglican College Owerrinta</span>
          </p>
          <Button
            variant="outline"
            size="sm"
            className="text-primary border-primary"
            onClick={() => setShowFull(false)}
          >
            Show Less
          </Button>
        </div>
      )}
    </div>
  );
}